// extracted by mini-css-extract-plugin
export var container = "filedUnder-module--container--aboia";
export var label = "filedUnder-module--label--yyTIW";
export var item = "filedUnder-module--item--U0wzp";
export var slideUp = "filedUnder-module--slideUp--7RzWf";
export var slideUpLarge = "filedUnder-module--slideUpLarge--34oRU";